import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { projectsData } from "../data/data";
import { motion } from "framer-motion";

function Projects() {
  const [selectedCountry, setSelectedCountry] = useState(
    localStorage.getItem("selectedCountry") || "egypt"
  );

  useEffect(() => {
    localStorage.setItem("selectedCountry", selectedCountry);
  }, [selectedCountry]);

  return (
    <div className="container mx-auto px-6 py-16">
      <h2 className="text-4xl font-bold text-center mb-12  decoration-gray-300 underline-offset-4 pb-2 w-fit mx-auto">
        Projects
      </h2>

      {/* أزرار البلاد */}
      <div className="flex justify-center gap-4 mb-8 flex-wrap">
        {Object.entries(projectsData).map(([countryId, country]) => (
          <button
            key={countryId}
            onClick={() => setSelectedCountry(countryId)}
            className={`px-6 py-2 rounded-md font-semibold transition duration-300 ${
              selectedCountry === countryId
                ? "bg-black text-white border-2 border-white"
                : "bg-gray-200 text-gray-800 hover:bg-gray-300 hover:scale-105"
            }`}
          >
            {country.name}
          </button>
        ))}
      </div>

      {/* المشاريع حسب البلد المختارة */}
      <h3 className="text-3xl font-bold mb-6 text-center">
        {projectsData[selectedCountry].name} Projects
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(projectsData[selectedCountry].projects).map(
          ([projectId, project], index) => (
            <motion.div
              key={projectId}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.8,
                delay: index * 0.1,
                ease: "easeOut",
              }}
              viewport={{ once: true, amount: 0.2 }}
            >
              <Link
                to={`/projects/${projectId}`}
                className="group relative block rounded-lg overflow-hidden shadow-lg"
              >
                <img
                  src={project.cover}
                  alt={project.name}
                  className="w-full h-72 object-cover transform transition duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition duration-500 flex items-center justify-center">
                  <span className="text-white text-lg font-semibold">
                    View {project.name}
                  </span>
                </div>
              </Link>
            </motion.div>
          )
        )}
      </div>
    </div>
  );
}

export default Projects;
